const RefundPolicy = () => {
  return (
    <div className="max-w-5xl mx-auto p-6  text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Refund Policy</h1>

      <p className="mb-4">Effective Date: 20/04/2025</p>
      <p className="mb-4">Website: www.thezaik.com</p>

      <p className="mb-4">
        At thezaik.com, we strive to provide high-quality, customized apparel
        and a seamless shopping experience. However, if you are not completely
        satisfied with your purchase due to specific issues, we are here to
        help.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        1. Eligibility for Refunds
      </h2>
      <p className="mb-4">
        Refunds are only applicable under the following conditions:
      </p>
      <h3 className="text-lg font-semibold mt-4 mb-2">
        1.1 Manufacturing Defect
      </h3>
      <p className="mb-4">
        If you receive a product with visible manufacturing defects (e.g., torn
        fabric, stitching errors, sizing issues due to tailoring mistakes), you
        are eligible for a refund.
      </p>

      <h3 className="text-lg font-semibold mt-4 mb-2">1.2 Payment Issues</h3>
      <p className="mb-4">You are entitled to a refund if:</p>
      <ul className="list-disc list-inside mb-4">
        <li>You are charged multiple times for the same order</li>
        <li>Your payment failed, but the amount was deducted</li>
      </ul>

      <h3 className="text-lg font-semibold mt-4 mb-2">
        1.3 Wrong Product Delivery
      </h3>
      <p className="mb-4">
        If you receive an item different from what you ordered, you may request
        a refund or replacement.
      </p>
      <p className="mb-4">
        Please note: We may ask for photos or videos of the defective or
        incorrect product to validate your request.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        2. Refund Request Timeline
      </h2>
      <p className="mb-4">
        Refund requests must be submitted within 7 days of:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Receiving the product (for delivery issues)</li>
        <li>The date of transaction (for payment-related concerns)</li>
      </ul>
      <p className="mb-4">
        Requests received after 7 days will not be eligible for a refund.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        3. Refund Review and Approval
      </h2>
      <p className="mb-4">
        Each refund request is reviewed on a case-by-case basis. Based on the
        nature of the issue, thezaik.com reserves the right to:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Approve or reject a refund request</li>
        <li>
          Issue a full or partial refund depending on the extent of the issue
        </li>
        <li>
          Offer an exchange or store credit as an alternative, where applicable
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">4. Refund Method</h2>
      <p className="mb-4">
        Approved refunds will be processed using the original method of payment
        used during checkout. For example:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Online payments will be refunded back to the card/bank used</li>
        <li>
          In case of COD refunds, customers will be asked to share valid bank
          account details
        </li>
      </ul>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        5. Refund Processing Time
      </h2>
      <p className="mb-4">
        Once approved, refunds are typically processed within:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>
          24 hours to 14 business days, depending on your payment provider or
          bank.
        </li>
      </ul>
      <p className="mb-4">
        Delays due to bank processing times are beyond our control, but we will
        provide you with confirmation once the refund is initiated.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">
        6. Contact for Refunds
      </h2>
      <p className="mb-4">
        To initiate a refund request, please email us with:
      </p>
      <ul className="list-disc list-inside mb-4">
        <li>Your Order ID</li>
        <li>Reason for the refund</li>
        <li>Supporting evidence (if applicable, such as photos of the item)</li>
      </ul>
      <p className="mb-4">
        📧 Email: zaikcare@gmail.com
        <br />
        📅 Refund Request Window: Within 7 days of issue
        <br />
        📍 Subject Line: "Refund Request – Order #[YourOrderID]"
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">7. Final Decision</h2>
      <p className="mb-4">
        All refund decisions will be made at the sole discretion of thezaik.com,
        and our decision will be considered final after a complete internal
        review.
      </p>
    </div>
  );
};

export default RefundPolicy;
